module.exports = __webpack_public_path__ + "static/printer-cycle-mobile-4379cbb75990be788b3a3551d08e4587.png";